import { render } from "./BoxedCountdown.vue?vue&type=template&id=4750e762&scoped=true"
import script from "./BoxedCountdown.vue?vue&type=script&lang=js"
export * from "./BoxedCountdown.vue?vue&type=script&lang=js"

import "./BoxedCountdown.vue?vue&type=style&index=0&id=4750e762&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4750e762"]])

export default __exports__